<template>
  <div class="no-user-item__message" data-test="no-user-item-message">
    <el-card>Aucun utilisateur</el-card>
  </div>
</template>
<script>
export default {
};
</script>
<style lang="scss" scoped>
</style>
